import * as types from "../../constants";

const initialState = {
  zonesSelected: [2, 5],
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case types.ADD_SELECTED_ZONE:
      return {
        ...state,
        zonesSelected: [...state.zonesSelected, action.zones],
      };

    default:
      return state;
  }
}
